export const createPluginData = (
  pluginData?: Record<string, string>
): Record<string, string> => {
  return {
    ...pluginData,
  };
};
